import styled from "@emotion/styled";
import ViewBlock from "../../../../img/butter_svgs/ViewBlock.svg?react";
import { Spacer } from "components/general/Spacer/Spacer";
import { Text } from "components/general/Text";
import { TransactionDetail } from "types/history";
import { openTransactionInBlockExplorer } from "utils/txUtils";
import React from "react";
import { css } from "@emotion/react";

interface ViewTxBtnProps {
  chainId: TransactionDetail["chain_id"];
  txHash: TransactionDetail["txHash"];
}

export const ViewTxBtn = ({ chainId, txHash }: ViewTxBtnProps) => {
  return (
    <Button onClick={() => openTransactionInBlockExplorer(chainId, txHash)}>
      <ViewBlock
        css={css`
          width: 20px;
          height: 20px;
        `}
      />
      <Spacer width="6px" />
      <Text textStyle="Button" size="Medium">
        View in explorer
      </Text>
    </Button>
  );
};

// Sub-components

const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 14px;
  padding: 13px 16px 13px 10px;
  color: ${props => props.theme.button.secondary.text.default};
  background-color: ${props => props.theme.button.secondary.surface.default};
  transition: background-color 150ms linear;

  &:hover {
    background-color: ${props => props.theme.button.secondary.surface.hover};
    color: ${props => props.theme.button.secondary.text.hover};
  }
`;
